<script lang="ts">
    import type {Video, ChatMessageAttachmentData} from "./Types";
    import Minithumbnail from "./Minithumbnail.svelte";
    import {authBlobUrl} from "../../Auth";
    export let attachments: ChatMessageAttachmentData[]
    export let entity: Video
</script>

<Minithumbnail entity="{entity.minithumbnail}"/><br/>
{#if attachments && attachments.length}
    {#each attachments as attachment}
        {#if attachment.telegram_remote_attachment_id == entity.video.remote.id}
            {#if attachment.status === 'pending'}
                Запис ще не викачаний
            {:else if attachment.status === 'failed'}
                Запис викачати не вдалось
            {:else if attachment.status === 'success'}
                {#await authBlobUrl('/attachments/'+attachment.id)}
                    <div class="spinner-grow"></div>
                {:then src}
                    {#if src}
                        <video controls style:width="100%">
                            <track kind="captions" src=""/>
                            <source {src} type="{entity.mime_type}">
                        </video>
                    {:else}
                        Не вдалось завантажити.
                    {/if}
                {:catch error}
                    Не вдалось завантажити.
                {/await}
            {/if}
        {/if}
    {/each}
{:else}
    Не викачано
{/if}
